import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

/**
 * Reusable two-step confirmation dialog with destructive styling.
 *
 * Props:
 *   open          - boolean
 *   title         - string
 *   message       - string
 *   confirmLabel  - string (default 'Confirm')
 *   cancelLabel   - string (default 'Cancel')
 *   onConfirm     - () => void
 *   onCancel      - () => void
 *   danger        - boolean (default true) — colours confirm button red
 */
const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
  danger = true,
}) => {
  return (
    <Modal
      isOpen={!!open}
      onRequestClose={onCancel}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      ariaHideApp={false}
      contentLabel={title || 'Confirm'}
      className="user-deletion-modal"
      overlayClassName="user-deletion-modal-overlay"
    >
      <div className="user-deletion-modal-card">
        {danger && (
          <div className="user-deletion-modal-icon" aria-hidden="true">⚠️</div>
        )}
        {title && <h2 className="user-deletion-modal-title">{title}</h2>}
        <p className="user-deletion-modal-message">{message}</p>
        <div className="user-deletion-modal-actions">
          <button
            type="button"
            className="user-deletion-cancel-btn"
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={danger ? 'user-deletion-danger-btn' : 'user-deletion-primary-btn'}
            onClick={onConfirm}
            autoFocus={false}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
};

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  danger: PropTypes.bool,
};

export default ConfirmDialog;
